import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { Equals, IsArray, IsBoolean, IsInstance, IsNotEmpty, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderElementTypeEnum } from '../enum';
import { OrderExposeGroup } from '../interface';
import { FixtureOrderItemDto } from './FixtureOrderItemDto';
import { FixtureOrderSelectionDto } from './FixtureOrderSelectionDto';
export class FixtureOrderSelectionGroupDto extends FixtureOrderItemDto {
    constructor() {
        super(...arguments);
        this.type = OrderElementTypeEnum.SELECTION_GROUP;
    }
}
__decorate([
    ApiProperty({ enum: OrderElementTypeEnum, default: OrderElementTypeEnum.SELECTION_GROUP }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    Equals(OrderElementTypeEnum.SELECTION, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderSelectionGroupDto.prototype, "type", void 0);
__decorate([
    ApiProperty({ type: () => FixtureOrderSelectionDto, isArray: true }),
    Type(() => FixtureOrderSelectionDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(FixtureOrderSelectionDto, { each: true, always: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], FixtureOrderSelectionGroupDto.prototype, "properties", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Element pos guid' }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], FixtureOrderSelectionGroupDto.prototype, "pos_guid", void 0);
__decorate([
    ApiProperty({ type: Boolean, description: 'should be always true', example: true }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], FixtureOrderSelectionGroupDto.prototype, "selected", void 0);
//# sourceMappingURL=FixtureOrderSelectionGroupDto.js.map